<template>
  <div class="signup-raiobutons" style="margin-top:60px;">
    <div
      v-for="paymentCredentialsBankCardType in paymentCredentialsBankCardTypes"
      :key="paymentCredentialsBankCardTypes.name"
      class="signup-rb--option"
      :class="{ selected: paymentCredentialsBankCardType.handle === selectedPaymentCredentialsBankCardTypes }"
      @click="setPaymentCredentialsType(paymentCredentialsBankCardType)"
    >
      <div class="signup-rb--option-rbtn">
        <div class="signup-rb--option-rbtn-marker" />
      </div>

      <div class="signup-rb--option-name">
        {{ paymentCredentialsBankCardType.name }}
      </div>

      <div class="signup-rb--option-desk">
        {{ paymentCredentialsBankCardType.description }}
      </div>

      <div
        v-if="paymentCredentialsBankCardType.confirmationCheckbox"
        class="signup-cb--option"
        :class="[
          paymentCredentialsBankCardType.handle === selectedPaymentCredentialsBankCardTypes
           ? { selected: isTermsOfPaymentConfirmed }
           : 'disabled'
        ]"
        @click.stop="toggleIsTermsOfPaymentConfirmed"
      >
        <div class="signup-cb--option-box">
          <div class="signup-cb--option-box-marker" />
        </div>

        <div class="signup-cb--option-name">
          {{ paymentCredentialsBankCardType.confirmationCheckbox.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BankCardPayment',
  model: {
    prop: 'isTermsOfPaymentConfirmed',
    event: 'input'
  },
  props: {
    paymentCredentialsBankCardTypes: {
      type: Array,
      required: true
    },
    isTermsOfPaymentConfirmed: {
      type: Boolean,
      required: true
    },
    selectedPaymentCredentialsBankCardTypes: {
      type: String,
      required: true
    }
  },
  methods: {
    setPaymentCredentialsType(paymentCredentialsType) {
      this.$emit('setPaymentCredentialsType', paymentCredentialsType);
    },
    toggleIsTermsOfPaymentConfirmed() {
      this.$emit('input', !this.isTermsOfPaymentConfirmed);
    }
  }
}
</script>
